import React from 'react';
import Body from './Body';

const View = (props) => {
  return (
    <div className="block search_progetti">
      <Body {...props} isEditMode={false} />
    </div>
  );
};

export default View;
